var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#395966"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 31,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1671 37.6468C20.0208 37.6468 22.3342 35.3189 22.3342 32.4471C22.3342 29.5755 20.0208 27.2476 17.1671 27.2476C14.3134 27.2476 12 29.5755 12 32.4471C12 35.3189 14.3134 37.6468 17.1671 37.6468Z",
    fill: "#FCBE1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9774 40.3156V25.3788L27.2096 25.2815L27.8869 25.0283C28.1578 24.9115 28.4868 24.8141 28.8545 24.6972C29.2222 24.5804 29.648 24.4635 30.1124 24.3467C30.5769 24.2299 31.0801 24.113 31.5832 24.0156C32.1057 23.9183 32.6669 23.8404 33.2669 23.7819C33.8668 23.7235 34.4668 23.6846 35.0667 23.6846C36.6342 23.6846 37.9502 23.9962 39.0339 24.6388C40.8918 23.9962 42.7883 23.6846 44.7042 23.6846C46.9878 23.6846 48.7682 24.2688 50.0648 25.4567C51.3614 26.6446 52.0001 28.3779 52.0001 30.6563V40.3156H46.3878V30.4227C46.3878 28.7284 45.6331 27.891 44.143 27.891C43.2915 27.891 42.5367 27.9884 41.8981 28.2026C42.169 29.0205 42.3045 29.8189 42.3045 30.559C42.3045 30.5979 42.3045 30.6174 42.3045 30.6369V40.2961H36.6923V30.3447C36.6923 28.7479 35.9956 27.9494 34.6022 27.9494C34.5828 27.9494 34.5828 27.9494 34.5635 27.9494C33.9829 27.9494 33.3249 28.0468 32.6089 28.2415V40.2961H26.9774V40.3156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAvatar);
export default __webpack_public_path__ + "static/media/logoAvatar.c0cf0b72319604b0f06a30788f4d6cf8.svg";
export { ForwardRef as ReactComponent };